module.exports = __webpack_public_path__ + "static/media/tumb2.4853ffae.png";